import React, { Component } from 'react';
import $ from 'jquery';
import AOS from 'aos';

import Header from '../components/Header';
import SectionBanner from '../components/SectionBanner';
import SectionAbout from '../components/SectionAbout';
import SectionJoin from '../components/SectionJoin';
import SectionTeam from '../components/SectionTeam';
import SectionTestimoni from '../components/SectionTestimoni';
import SectionPricing from '../components/SectionPricing';
import SectionContact from '../components/SectionContact';
import Footer from '../components/Footer';
import SectionSupport from '../components/SectionSupport';
import Modal from '../components/Modal'

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: null
    }
    this.isModalSuccess = this.isModalSuccess.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  componentDidMount() {
    AOS.init({
      duration: 500,
      easing: 'slide'
    });
    
    setTimeout(function() { 
			if($('#ftco-loader').length > 0) {
				$('#ftco-loader').removeClass('show');
			}
    }, 1000);
  }

  isModalSuccess(param) {
    if (param) {
      this.setState({showModal: <Modal isShow={this.closeModal} />})
    }
  }

  closeModal(isClose) {
    if (isClose === false) {
      this.setState({
        showModal: null
      })
    }
  }

  render() { 
    return (
      <div data-spy="scroll" data-target=".site-navbar-target" data-offset="300">
        <Header />
        <SectionBanner />
        <SectionAbout />
        <SectionJoin />
        <SectionTeam />
        {/* <SectionPricing /> */}
        <SectionTestimoni />
        <SectionSupport />
        <SectionContact isModalSuccess={this.isModalSuccess} />
        <Footer />

        {/* loader */}
        <div id="ftco-loader" className="show fullscreen">
          <svg className="circular" width="48px" height="48px">
            <circle className="path-bg" cx="24" cy="24" r="22" fill="none" strokeWidth="4" stroke="#eeeeee"/>
            <circle className="path" cx="24" cy="24" r="22" fill="none" strokeWidth="4" strokeMiterlimit="10" stroke="#F96D00"/>
          </svg>
        </div>
        {this.state.showModal}
      </div>
    );
  }
}
 
export default Home;